import React, { useEffect, useState } from "react";
import {
    Layout,
    Typography,
    Breadcrumb,
    Switch,
    Select,
    Button,
    Table,
    Row,
    Col,
    Space,
    Spin,
    Form,
    Card
} from "antd";
import {
    FilePdfOutlined,
    FileExcelOutlined,
    CheckOutlined,
    ClearOutlined,
    SearchOutlined
} from "@ant-design/icons";
import Headerdiv from "../../layout/header.js";
import Footerdiv from "../../layout/footer.js";
import { APPBACKGROUND_COLOR, MAINAPIURL } from "../../appsettings.js"; // COMPANYLOGO removed as it's used in stock-report-pdf.js
import axios from "axios";
import { AlertError } from "../../usableclasses.js";
import { StockReportDocument } from './stock-report-pdf.js'; // Import the new component
import { handleExportToExcel } from './stock-report-excel.js'; // Import the new Excel export function
import { PDFDownloadLink } from '@react-pdf/renderer';
import { Link } from "react-router-dom";
const { Title } = Typography;
const { Content } = Layout;
const { Option } = Select;

const columns = [
    {
        title: "Product Code",
        dataIndex: "itemSku",
        key: "productCode",
    },
    {
        title: "Name",
        dataIndex: "itemName",
        key: "itemName",
    },
    {
        title: "Size",
        dataIndex: "itemSize",
        key: "itemSize",
    },
    {
        title: "UOM",
        dataIndex: "unitOfMeasure",
        key: "unitOfMeasure",
    },
    {
        title: "Available Qty",
        dataIndex: "availableQty",
        key: "availableQty",
    },
    {
        title: "Total Stock Value",
        dataIndex: "itemTotalCostValue",
        key: "itemTotalCostValue",
    },
];

const StockReport = () => {
    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const [isLoading, setIsLoading] = useState(false)
    const [stockItems, setStockItems] = useState([]);
    const [stocks, setStocks] = useState([]);
    const [allStocks, setAllStocks] = useState(true);
    const [selectedStock, setSelectedStock] = useState(null);

    useEffect(() => {
        fetchStocks();
    }, []);

    const fetchStocks = async () => {
        try {
            setIsLoading(true)
            const headers = { SystemAccessToken: TOKEN };
            const res = await axios.get(`${ApiURL}/stocks/all`, { headers });
            setStocks(res.data);
        } catch (error) {
            AlertError("Failed to Load Stocks");
        } finally {
            setIsLoading(false)
        }
    }

    const fetchStockItems = async () => {
        try {
            setIsLoading(true)
            const headers = { SystemAccessToken: TOKEN };
            if (allStocks) {
                const response = await axios.get(`${ApiURL}/reports/stock/livestock/all`, { headers });
                setStockItems(response.data);
            } else {
                const res = await axios.get(`${ApiURL}/reports/stock/livestock/${selectedStock}`, { headers });
                setStockItems(res.data);
            }
        } catch (error) {
            AlertError("Failed to Load Stock Items");
        } finally {
            setIsLoading(false)
        }
    }

    const getSelectedStockName = () => {
        if (allStocks || !selectedStock || !stocks || stocks.length === 0) {
            return 'All Stocks';
        }
        const stock = stocks.find(s => s.stockId === selectedStock);
        return stock ? stock.stockName : 'N/A';
    };

    return (
        <Spin spinning={isLoading} tip="Processing...">
            <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
                <Headerdiv />
                <Content style={{ padding: "10px" }}>
                    <Breadcrumb style={{ margin: "16px 0" }}>
                        <Breadcrumb.Item><Link to={"/reports"}>Reports</Link></Breadcrumb.Item>
                        <Breadcrumb.Item>Live Stock Report</Breadcrumb.Item>
                    </Breadcrumb>

                    <Card style={{ marginBottom: 20 }} title={
                        <Row align="middle" justify="space-between">
                            <Col span={12}>
                                <Title level={3} style={{ textAlign: 'left', margin: 0 }}>Live Stock Report</Title>
                            </Col>
                            <Col span={12} style={{ textAlign: 'right' }}>
                                <Space>
                                    <PDFDownloadLink
                                        document={<StockReportDocument data={stockItems} selectedStockName={getSelectedStockName()} />}
                                        fileName={`Stock_Report_${new Date().toLocaleDateString()}.pdf`}
                                    >
                                        <Button
                                            disabled={stockItems.length === 0}
                                            type="primary"
                                            style={{ backgroundColor: "#dc3545", borderColor: "#dc3545" }}
                                            icon={<FilePdfOutlined />}>Download PDF</Button>
                                    </PDFDownloadLink>
                                    <Button
                                        disabled={stockItems.length === 0}
                                        type="primary"
                                        style={{ backgroundColor: "#28a745", borderColor: "#28a745" }}                                        icon={<FileExcelOutlined />}
                                        onClick={() => handleExportToExcel(stockItems, getSelectedStockName())}
                                    >
                                        Export to Excel
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    } >
                        <Form onFinish={fetchStockItems} layout="inline" style={{ width: '100%' }} >
                            <Row xs={24} sm={24} md={24} align="middle" gutter={[16, 16]} style={{ width: '100%' }} justify="space-evenly">
                                <Col xs={24} sm={8} md={3}>
                                    <Form.Item label="All Stocks" style={{ marginBottom: 0 }}>
                                        <Switch
                                            checked={allStocks}
                                            onChange={(checked) => setAllStocks(checked)}
                                            style={{ marginRight: 8 }}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={10} md={6}>
                                    <Form.Item label="Select Stock" style={{ marginBottom: 0 }}>
                                        <Select
                                            style={{ width: '100%' }}
                                            placeholder="Select a stock"
                                            value={selectedStock}
                                            onChange={(value) => setSelectedStock(value)}
                                            disabled={allStocks}
                                            allowClear
                                            suffixIcon={<CheckOutlined />}
                                            options={stocks.map((stock) => ({
                                                value: stock.stockId,
                                                label: stock.stockName,
                                            }))}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={6} md={3} style={{ display: 'flex', alignItems: 'end' }}>
                                    <Button 
                                    htmlType="submit" 
                                    type="primary" 
                                    icon={<SearchOutlined/>}
                                    style={{ width: '100%' }}>Get Data</Button>
                                </Col>
                                <Col xs={24} sm={6} md={3} style={{ display: 'flex', alignItems: 'end' }}>
                                    <Button
                                        style={{ width: '100%' }}
                                        icon={<ClearOutlined />}
                                        onClick={() => {
                                            setAllStocks(true);
                                            setSelectedStock(null);
                                            setStockItems([]);
                                        }}
                                    >
                                        Clear
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card>

                    <Card title="Stock Items" style={{ marginBottom: 20 }}>
                        <Table
                            style={{ marginTop: 20 }}
                            columns={columns}
                            dataSource={stockItems}
                            pagination={false}
                            bordered
                            scroll={{ x: "max-content" }}
                        />
                    </Card>
                </Content>
                <Footerdiv />
            </Layout>
        </Spin>
    );
};

export default StockReport;
